import React, { useState } from "react";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

// CPTELL-245: reusable password field with a show/hide eye toggle.
// Drop-in for the portal's plain <input type="password"> fields — pass the same
// props (value, onChange, id, style, className). Width and vertical margins from
// `style` are moved to the wrapper so the eye anchors to the field, not the margin.
const RevealPasswordInput = ({ style = {}, className, wrapperStyle = {}, ...rest }) => {
  const [show, setShow] = useState(false);
  const { width, marginBottom, marginTop, ...inputStyle } = style;
  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        width: width || "100%",
        marginBottom,
        marginTop,
        ...wrapperStyle,
      }}
    >
      <input
        {...rest}
        className={className}
        type={show ? "text" : "password"}
        style={{ ...inputStyle, width: "100%", boxSizing: "border-box", paddingRight: 40 }}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        title={show ? "Hide password" : "Show password"}
        style={{
          position: "absolute",
          right: 6,
          top: 0,
          bottom: 0,
          height: 24,
          margin: "auto 0",
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          color: "#6c757d",
          display: "flex",
          alignItems: "center",
          lineHeight: 0,
        }}
      >
        {show ? <VisibilityOff style={{ fontSize: 20 }} /> : <Visibility style={{ fontSize: 20 }} />}
      </button>
    </div>
  );
};

export default RevealPasswordInput;
